import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
let store = new Vuex.Store({
	state: {
		stateObject: {
			themeCss: {
				color: "#FF8F00"
			},
			parmStr: "",
			parmPass: null,
			pageMap: {},
			userInfo: {},
			projectData: {},//项目详情
			isEditProjectInfoSuccess: false,//是否编辑项目信息成功
			isAdjustPersonnel: false,//是否分配任务
			customerInfo: "",//业主详情
			signCustomer: {},//签约业主
			isUpdateCustomerSuccess: false,//是否编辑业主信息成功
			selectedGiftItem: null,//选择礼物
			selectedGiftType: 0,
			customerId: "",//业主ID
			isAddServiceSuccess: false,//是否添加服务费成功
			isRefundSuccess: false,//是否退款成功
			yxparkInfo: null,//意向车位
			finalDetail: {},//尾款对象
			isSavePaymentSuccess: false,//是否保存尾款成功
			isSaveSignSuccess: false,//是否保存签约成功
			isAddEntranceSuccess: false,//是否添加场次成功
			isReportedSuccess: false,//是否报备成功
			isProcessSuccess: false,//是否选择项目流程
			processProject: "",//项目流程选择项目
			backRefreshPage: false,//回退是否刷新上级页面
			isAddFollowSuccess: false,//是否添加项目跟进成功
			isSelectedYxparkInfo: false,//是否选择意向车位
			isRefreshCheckList: false,//是否选择意向车位
			bankList: [],//选中的银行卡
			statisticsDetailProject: "",//统计选择项目
			deviloperInfo: null,//开发商信息
			resDetail: {
				projectIds: ""
			},//资源详情
			isUpdateResSuccess: false,//修改资源成功
			propertyInfo: null,//物业信息
			auditLog: null,//拓展审核记录
			relevanceProjectId: null,//关联项目Id
			tagListJson: "",//标签列表
			msgToailCount: 0,//消息总数量
			backRefreshMsgPage: false,//刷新消息界面
			feedBackIsRead: false,//是否有未读意见反馈消息
			relationResourceProject: [],//资源项目传值
			scoreProjectInfo: null,//选择打分项目
			gpsLocalInfo: null,//选择定位信息
			settlementDetailInfo: null,
			isRefersh: false,
			stallFoorInfo: null,//车位楼层信息
			staffRespsList: [],//资源共享人
			settlementInfoJson: null,//结算对象
			newUploadFile: null,//新增附件内容
			projectGiftPlant: null,//项目礼品预算
			updateSummaryData: [],//数据表修改对象
			newUploadFile: null,//新增附件内容
			projectGiftPlant: null,//项目礼品预算
			selectRelation: null,//资源关联资源
			developers: null,//开发商列表到详情信息
			settlementLists: null,//结算信息表
			statisticalTransmissionParameter: null,//统计跳转各页面传参
			recordIds: null,//选择录音返回
			passRecordList: null,//跟进详情查看关联录音列表
			selectRelationDeveloperAndProperty: null,//资源关联资源
			paymentDetail: null,//付款记录查看详情
			baiduToken: "",//百度账号登录Token
			sendGiftEditData: null,//用于资源送礼修改更新列表
			CCStaffData: null,//oa选择抄送人传值
			projectForecastRespItem: null,//预测销量
			sameIndustrySaleData: null,//同行销售情况
			pressForMoneyProject: "",//催收选择项目
			pressForMoneyData: "",//催收信息
			searchProjectData: null,//项目筛选返回
			signPerson: null,//项目详情签约人
			paymentStatusRecord: null,//预打款记录
			developersFollowUpDetail: null,//开发商跟进详情
			isIgnoreReplay: false,//工作台是否忽略复盘弹窗
			competitorSelectData: null,//数据表选择竞争对手（同行）传值
			// isShowPressMoneyAlert:false,//待跟进保证金弹框
			isShowPressMoneyAlertList: null,//保证金弹框数据(列表中的type：1待跟进；2已损失)
			isNoticeIndex: null,//催收消息状态索引
			// isShowPressMoneyLostAlert:false,//待跟进保证金损失弹框
			staffIntegral: 0,//员工积分
			medalNum: 0,//勋章个数
			staffViolationNumber: 0,//违纪次数
			selectProjectManagerIds: '',//选择因业绩好签约的销售经理 项目hisIds
			selectProjectManagerNames: '',//选择因业绩好签约的销售经理 项目names
			contractTimeAlert: null,//库存车位/过户时间已到期
			betweenTwoPartiesItem: null,//居间协议编辑传值
			toDoListParm: null,//待办事项传值
			contractString: '',//合同
			isRefresh: false,
			deleteResourceId: "",//删除资源ID
			simulationManagerSelects: "",//项目推演选择经理
			getTokening: false,//正在刷新token
			alertOut: false,//正在弹框退出
			tokenRefreshTime: new Date(),//记录第一次登录时间
			refereeData: [],//待复盘转交人
			selectSpaceTime: ["time1", "time2", "time3"],//time1:disable截止时间，time2：开始时间，time3：结束时间
			signProcessBackData: null,//签约流程预关联项目
			addReplaySelectData: null,//待复盘新增选择项目场次或合同
			selectSWOTData: { nowMethodData: null, nowType: null },//选中的项目评估
			passSWOTData: null,//鱼骨数据
			sharedByData: null,//项目详情到跟进记录传递共享人信息
			selectSWOHHisTime: null,//预测销量选择场次
			passSettlementDetail: null,//结算信息
			passSettlementDetailChild: null,//结算信息
			purchaseGoodsPara: [],//采购选择商品传值
			isSelectRes: false,//是否选择资源
			expandGiftPerson: null,//送礼人身份
			labelFilteringParam: [],//资源筛选标签
			developerObj: { developerId: "", developerName: "", projectList: [] },//开发商信息
			selectDBArray: [],//选择拓展人员数据
			newResourceParams: {},//新增资源页面部分参数
			addResRelatedProjectId: "",//新增资源关联项目id
			originalCompanyParams: {}, //原任职公司参数
			itemConfirmationData: [],//物品确认
			originalDeveloperId: "",//开发商ID
			originalDeveloperName: "",//开发商名称
			customerServiceFee: [], //客情推荐费详情
			secondCustomerServiceFee: {}, //二级页面客户推荐费详情
			projectName: "",
			totalCount: 0,//商学院各模块待办总数
			BusinessCollegeCount: 0,//商学院代办
			dailyOncePracticeCount: 0,//每日一练待办
			weeklyOncePracticeCount: 0,//每周一练待办
			weeklyOncePassCount: 0,//每周一通待办
			draftContractInfo: null,//定稿合同拓展更改信息
			draftId: null,
			selectInfoStr: "",
			questionDetail: {},
			projectTags: [],//项目标签
			expectSignProjectData:null,//预计签约数据
			reserveProjectData:null,//储备项目数据
			dataModelCommonEditPassData:null,//项目评估传值
			resourcePassData:null,//资源信息
			competitorDataNew:null,//新竞争对手
			competitorProjectRelationData:null,//竞争对手打盘情况
			dataModelHistoryData:null,//项目评估历史
			resourceFollowRelationProject:null,//资源跟进关联项目
			reportData:null,//问卷调查
			meetingObj:null,
			isSaveJCL:false,//已保存决策链
			selectDeveloperData: [],
			callCenterItem: null,//呼叫中心列表数据项
			callCenterDetailItem: null,//呼叫详情数据项
			callUrlArry: null,//录音数据
		    regionPoliciesObj: null,//地方政策
			backRefreshResource: false,
			developersContactInformation:null,//开发商资源联系信息
			addddRecourceIdByDevelopersContactInformation:"",//添加开发商资源联系信息资源ID
			selectPersonsForBorrowing:null,//物品借用选择人员
			feedbackChangeObj: null,//反馈保存
			signProcessEx1ChildData:null,//拓展流程传参
			isSaveFromSop:false,//拓展流程相关保存
			parkPicture: null,//项目详情车位图片
			addParkPicture: null,
			referrerStaffList: [],//资源推荐人
			backRefreshSummaryTablePage: false,//回退是否刷新数据表
			resGroupEditData:null,//资源跟进客户数据
			projectSiteVisitSelectData:null,//选择深度实勘表
			publicAreaResource:null,//公域资源
			getCurrentSettlementListData:null,//结算数量填写后传参
			commonResourceRelation:null,//关联资源
			relationCustomerData:null,//选择关联客户
			customerBackRefreshPage:false,//客户关联跟进刷新
			customerSynRelation:null,//客户关联同步
			swotGoosOrBadSelect:null,//swot选择利空利好
			newToken:"",
			selectPlanDate:"",//客户计划选择日期
			backRefreshPlanFollow:false,//刷新计划页面跟进详情
			resourceSourcePass:null,//资源来源选择
			resourceRecommend:null,//资源推荐添加资源
			resLabData:null,//编辑资源选择标签
			noWorkPlanEditPass:null,//批量创建客户计划传值
			settlementPassEditData:null,//结算编辑
			isSaveBusiness:false,//是否添加商机
			businessEditSelectProjects: null,//商机编辑选择项目
			recordingDeviceOnlineStatus: null,
			interviewRecordingText: null,//录音转文本
			customerRecomendRelation:null,//推荐客户选择三方公司
			faceAudioFollowPassAIData:null,//面谈录音关联资源写跟进传递AI数据
			customerGroupFourBusiness:null,//商机数据
			customerGroupFourBusinessAuditDetail:null,//商机评审数据
			selectDuduTalkId:null,//选择嘟嘟ID
			relevanceProjectArry: null,//关联项目列表
			relatedFileObj: null,//相关文件对象
			validateBusinessResultData:null,//验证商户结果
			internalTransferCollectionAccountSelect: null,//内部转账，借款选择账户
		}

	},
	mutations: {
		stateFn(state, source) {
			let stateObject = state.stateObject;
			for (let i in source) {
				let key = stateObject[i];
				if (key) {
					let newObj = deepClone({}, state.stateObject[i], source[i]); //这样深拷贝没有getter,setter属性
					let o = {};
					o[i] = newObj;
					Object.assign(state.stateObject, o); //这样就有了getter,setter属性
				}
			}
		},
		stateFn2(state, source) {
			Object.assign(state.stateObject, source);
		}
	}
})

function _type(obj, name) {
	return Object.prototype.toString.call(obj) === "[object " + name + "]";
}

function isPlainObject(obj) {
	return !!obj && _type(obj, 'Object') && _type(obj.isPrototypeOf, 'Function');
}

function deepClone() {
	var target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false,
		options, name, src, copy;
	if (typeof target === "boolean") {
		deep = target;
		target = arguments[1] || {};
		i = 2;
	}
	if (typeof target !== "object" && !_type(target, 'Function')) {
		target = {};
	}
	if (length === i) {
		target = this;
		--i;
	}
	for (; i < length; i++) {
		if ((options = arguments[i]) != null) {
			for (name in options) {
				src = target[name];
				copy = options[name];
				if (target === copy) {
					continue;
				}
				if (deep && copy && (isPlainObject(copy) || _type(copy, 'Array'))) {
					var clone = (src && (isPlainObject(src) || _type(src, 'Array'))) ? src : (_type(copy, 'Array') ? [] : {});
					target[name] = deepClone(deep, clone, copy);
				} else if (copy !== undefined) {
					target[name] = copy;
				}
			}
		}
	}
	return target;
}

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js